import logo from "../assets/Logo.png";
import { styled } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Logo = styled("img")<{ $size: number; $interactive: boolean }>(
  ({ $size, $interactive }) => ({
    width: `${$size}px`,
    height: `${$size}px`,
    ...($interactive
      ? {
          ":hover": {
            cursor: "pointer",
            transform: "scale(1.1)",
          },
        }
      : { cursor: "default" }),
  }),
);

interface MainLogoProps {
  /** Figma auth header uses a 48px logo frame; other legacy surfaces stay 40px. */
  size?: number;
  /** Decorative brand lockup usage must not navigate away from authentication. */
  interactive?: boolean;
}

export default function MainLogo({
  size = 40,
  interactive = true,
}: MainLogoProps) {
  const navigate = useNavigate();
  return (
    <Logo
      $size={size}
      $interactive={interactive}
      src={logo}
      alt="Logo"
      onClick={interactive ? () => navigate("/home") : undefined}
    />
  );
}
